<template>
  <div class="settings-fields">
    <div class="field-group">
      <div class="flabel">
        <FieldStatusIcon :ok="Boolean(settings['salonName'] && settings['salonName'].trim().length > 0)" />
        <span>Название салона в подписи к сообщениям</span>
      </div>
      <BaseInputOutlined
        label="Введите название"
        :value="settings['salonName']"
        @input="updateSetting('salonName', $event)"
        class="custom-input mock-input"
        hide-details
      />
    </div>

    <div class="field-group">
      <div class="flabel">
        <FieldStatusIcon :ok="Boolean(settings['salonAddress'] && settings['salonAddress'].trim().length > 0)" />
        <span>Адрес салона в подписи к сообщениям</span>
      </div>
      <BaseInputOutlined
        label="Введите адрес"
        :value="settings['salonAddress']"
        @input="updateSetting('salonAddress', $event)"
        class="custom-input mock-input"
        hide-details
      />
    </div>

    <div class="field-group">
      <div class="flabel">
        <FieldStatusIcon :ok="isValidPhone(get(settings, 'salonPhone'))" />
        <span>Контактный телефон в подписи к сообщениям</span>
      </div>
      <ValidationInput
        :rule="phoneValidator"
        label="+7 (999) 123-45-67"
        :value="settings['salonPhone']"
        @input="updateSetting('salonPhone', $event)"
        class="phone-input mock-input"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import BaseInputOutlined from '@/components/inputs/BaseInputOutlined.vue'
import ValidationInput from '@/components/inputs/ValidationInput.vue'
import FieldStatusIcon from '@/components/ClientNotifications/NotificationSettingsBlocks/FieldStatusIcon.vue'

export default defineComponent({
  name: 'CommonSettingsBlock',
  components: { BaseInputOutlined, ValidationInput, FieldStatusIcon },
  props: {
    settings: { type: Object, required: true },
    updateSetting: { type: Function, required: true },
    phoneValidator: { type: Function, required: true },
    isValidPhone: { type: Function, required: true },
    get: { type: Function, required: true },
    showPhoneForNotification: { type: Boolean, default: true },
  },
})
</script>

<style lang="sass" scoped>
.settings-fields
  display: flex
  flex-direction: column
  gap: 14px

.field-group
  display: flex
  flex-direction: column
  gap: 9px

.flabel
  display: flex
  align-items: center
  gap: 7px
  font-size: 13px
  color: #1F2440
</style>
